<template>
<div class="chapter">
<div class="inner_page">
<p class="center3a"><span>For Gerard J. Hughes</span></p>
<p class="center"><span>Head of the Department of Philosophy</span></p>
<p class="center"><span>Heythrop College, University of London 1974-1998</span></p>
<p class="center"><span>Master of Campion Hall, University of Oxford, 1998-2006</span></p>
<p class="center1"><span>A great teacher</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7726e1fc